var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClone = function SvgClone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.1001,
    width: 13.4,
    height: 13.4,
    rx: 1.5,
    fill: "#8075E6",
    stroke: "#8075E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.59961 5.7C6.59961 4.20883 7.80844 3 9.29961 3H18.2996C19.7908 3 20.9996 4.20883 20.9996 5.7V14.7C20.9996 16.1912 19.7908 17.4 18.2996 17.4H9.29961C7.80844 17.4 6.59961 16.1912 6.59961 14.7V5.7ZM9.29961 4.8C8.80255 4.8 8.39961 5.20294 8.39961 5.7V14.7C8.39961 15.1971 8.80255 15.6 9.29961 15.6H18.2996C18.7967 15.6 19.1996 15.1971 19.1996 14.7V5.7C19.1996 5.20294 18.7967 4.8 18.2996 4.8H9.29961Z",
    fill: "#8075E6"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Clone.a84dac77ec6fa6e133979d22afb45e2c.svg";